import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'app-bill-positions',
    templateUrl: './bill-positions.component.html',
    styleUrls: ['./bill-positions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BillPositionsComponent implements OnInit {
  mainTitle = 'Bill Positions & Legislative Updates'

  constructor() {}

  ngOnInit(): void {}
}
